import { ExecuteQueryRequest, ProcessQueryRequest } from "../models/process.model";
import HttpService from "./http.service";

const basePath = ""; // nao ta usando bse serviceControllers.PROCESS;

export const ProcessService = {
	getQueries,
	saveQuery,
	saveAndExecuteQuery,
	executeQuery,
	getQueryByName,
	getProcesses,
	deleteQuery,
	getTribunais,
};

// 🔍 Buscar queries salvas
async function getQueries() {
	try {
		const response = await HttpService.get(`${basePath}/Process/GetQueries`);
		return response;
	} catch (error) {
		console.error("Erro ao buscar queries:", error);
		throw error;
	}
}

// 🔍 Buscar uma query pelo nome
async function getQueryByName(queryName: string) {
	try {
		const response = await HttpService.get(
			`${basePath}/Process/query/${encodeURIComponent(queryName)}`
		);
		return response;
	} catch (error) {
		console.error("Erro ao buscar query por nome:", error);
		throw error;
	}
}

// 💾 Salvar uma query
async function saveQuery(payload: ProcessQueryRequest) {
	try {
		const response = await HttpService.post(`${basePath}/Process/SaveQuery`, payload);
		return response;
	} catch (error) {
		console.error("Erro ao salvar query:", error);
		throw error;
	}
}

// 💾▶️ Salvar e executar query
async function saveAndExecuteQuery(payload: ProcessQueryRequest) {
	try {
		const response = await HttpService.post(
			`${basePath}/Process/SaveAndExecuteQuery`,
			payload
		);
		return response;
	} catch (error) {
		console.error("Erro ao salvar e executar query:", error);
		throw error;
	}
}

// ▶️ Executar uma query existente
async function executeQuery(payload: ExecuteQueryRequest) {
	try {
		const response = await HttpService.post(
			`${basePath}/Process/ExecuteQuery`,
			payload
		);
		return response;
	} catch (error) {
		console.error("Erro ao executar query:", error);
		throw error;
	}
}

async function getProcesses(executionId: string) {
	try {
		const response = await HttpService.post(`/Process/GetProcesses/${executionId}`,{});
		return response;
	} catch (error) {
		console.error("Erro ao buscar processos:", error);
		throw error;
	}
}

async function deleteQuery(queryName: string) {
	try {
		const response = await HttpService.delete(`Process/DeleteQuery/${queryName}`);
		return response;
	} catch (error) {
		console.error("Erro ao excluir query:", error);
		throw error;
	}
}

// 🔍 Buscar lista de tribunais
async function getTribunais() {
    try {
        const response = await HttpService.get(`${basePath}/Process/GetTribunais`);
        return response;
    } catch (error) {
        console.error("Erro ao buscar tribunais:", error);
        throw error;
    }
}


export default ProcessService;
